// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-infinite-scroll[data-v-9c71210e]{height:100%;text-align:center}.custom-infinite-scroll--hidden-spinner[data-v-9c71210e]{transform:translateY(100px)}.custom-infinite-scroll__spinner[data-v-9c71210e]{min-height:100%}", ""]);
// Exports
module.exports = exports;
